import { gql } from "@apollo/client";

export const UNIFIED_CHECKOUT = gql`
  mutation UnifiedCheckout($products: [PriceIDWithQuantityInput!]!, $attemptId: String) {
    unifiedCheckout(products: $products, attemptId: $attemptId)
  }
`; 